import { Alert } from '@material-ui/lab';
import React from 'react';
import JSONInput from 'react-json-editor-ajrm';
import { BackButton, PrimaryButton } from '../../components/AtomComponents';
import { localeEn } from '../ConfigTenant/ConfigTenant';
import { Wait } from './SchemaSync';
import QueryReviewConfirmationDialog from './QueryReviewConfirmationDialog';
import useVerticalSyncV3, { IProps } from './useVerticalSyncV3';
import { columnDefsV3 } from './queryReviewUtils';
import { VerticalSyncV3Form } from './VerticalSyncV3Form';

const VerticalSyncV3 = ({ syncFor }: IProps) => {
  const {
    environment, setEnvironment, release, setRelease, tenantId, setTenantId,
    isTransactionPerTenant, processState, setProcessState, previewState,
    reviewQueriesConfirmationDialog, reviewData, schemaSync,
    openReviewQueriesConfirmationDialog, closeReviewQueriesConfirmationDialog, onApprove, confirm
  } = useVerticalSyncV3({ syncFor });

  const dialogContent = (
    <>This is to sync across <b>{environment?.toUpperCase()}</b>. Do you really want to execute it?</>
  );

  const handleSyncClick = () => confirm({
    content: dialogContent,
    confirmText: 'Sync',
    cancelText: 'Cancel',
    onConfirm: schemaSync,
  });

  return (
    <>
      <div className="cell small-6 medium-6 px-one-line-data margin-bottom-2">
        <BackButton />
        <h3 className="small-12 margin-bottom-1">Sync across Environment V3</h3>
      </div>

      {processState === 0 && (
        <VerticalSyncV3Form
          formValues={{ environment, setEnvironment, release, setRelease, tenantId, setTenantId }}
          isTransactionPerTenant={isTransactionPerTenant}
          actions={{ onReviewClick: openReviewQueriesConfirmationDialog, onSyncClick: handleSyncClick }}
        />
      )}

      {processState === 1 && <Wait />}

      {processState === 2 && (
        <>
          <div className="margin-bottom-3">
            <JSONInput
              id={`${syncFor}-vertical-v3-jsonEditor`}
              theme="light_mitsuketa_tribute"
              locale={localeEn}
              placeholder={previewState}
              height="550px"
              width="100%"
              viewOnly={true}
              style={{ body: { fontSize: '16px' } }}
            />
          </div>
          <Alert severity="success" className="margin-bottom-3">
            Schema sync completed!
          </Alert>
          <PrimaryButton onClick={() => setProcessState(0)}>Restart</PrimaryButton>
        </>
      )}

      <QueryReviewConfirmationDialog
        isOpen={reviewQueriesConfirmationDialog}
        onClose={closeReviewQueriesConfirmationDialog}
        onApprove={onApprove}
        reviewQueries={openReviewQueriesConfirmationDialog}
        meta={{ environment, release }}
        reviewData={reviewData}
        columnDefs={columnDefsV3}
      />
    </>
  );
};

export default VerticalSyncV3;
